import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import useToolbarSetter from '../../hooks/Common/useToolbarSetter';
import NotificationChannelCard, { NotificationChannel } from './NotificationChannelCard';

const NotificationChannelToast = ({ channelName, enabled }: { channelName: string; enabled: boolean }) => {
  return (
    <div className='d-flex flex-row align-items-center justify-content-between gap-4'>
      <div className='d-flex align-items-center gap-3'>
        <i className={`bi ${enabled ? 'bi-toggle-on text-success' : 'bi-toggle-off text-danger'} fs-2x`} />
        <div>
          <div className='fw-bold'>{channelName}</div>
          <div className='text-muted fs-7'>{enabled ? 'Notifications turned on.' : 'Notifications turned off.'}</div>
        </div>
      </div>
    </div>
  );
};

const NotificationChannels = () => {
  const { setToolbar } = useToolbarSetter();

  useEffect(() => {
    setToolbar('notification-channels', 'Canale notificari');
  });

  const [channels, setChannels] = useState<NotificationChannel[]>([
    {
      id: 'email',
      name: 'Email',
      label: 'Email address',
      value: 'alerts@securifai.com',
      enabled: true,
      icon: 'bi-envelope',
      description: 'Receive alerts by email.',
    },
    {
      id: 'push',
      name: 'Push Notifications',
      label: 'Channel',
      value: 'Administrators',
      enabled: false,
      icon: 'bi-bell',
      description: 'Receive alerts on the mobile app.',
    },
    {
      id: 'teams',
      name: 'Teams',
      label: 'Webhook URL',
      value: 'https://outlook.office.com/webhook/xxxxx',
      enabled: true,
      icon: 'bi-microsoft-teams',
      description: 'Send alerts to a Teams channel.',
    },
  ]);

  const handleToggle = (id: string) => {
    const target = channels.find((channel) => channel.id === id);
    if (!target) return;

    const nextEnabled = !target.enabled;

    toast.warning(<NotificationChannelToast channelName={target.name} enabled={nextEnabled} />, {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      icon: false,
    });

    setChannels((prevState) =>
      prevState.map((channel) => (channel.id === id ? { ...channel, enabled: nextEnabled } : channel))
    );
  };

  const handleValueChange = (id: string, value: string) => {
    setChannels((prevState) => prevState.map((channel) => (channel.id === id ? { ...channel, value } : channel)));
  };

  return (
    <div className='container px-sm-5 pt-3'>
      <div className='row'>
        {channels.map((channel) => {
          return (
            <NotificationChannelCard
              key={channel.id}
              channel={channel}
              onToggle={handleToggle}
              onValueChange={handleValueChange}
            />
          );
        })}
      </div>
    </div>
  );
};

export default NotificationChannels;
